import { IProductResult, ISearchResponse, ProductSearchParams } from '@api-client/src/api/types';
import { useSearchFactory } from '@vue-storefront/core';

import { mapToSearchParams } from '../helpers/mapToSearchParams';
import { mapToSearchResponse } from '../helpers/mapToSearchResponse';

const useSearch = useSearchFactory<ISearchResponse<IProductResult[]>, ProductSearchParams>({
  search: async (context, params) => {
    try {
      const facetMaps = params.facetMaps;

      const mappedParams = mapToSearchParams(params);
      const productSearchResponse = await context.$search.api.productSearch(mappedParams);
      const productSearchResponseMapped = mapToSearchResponse(productSearchResponse, facetMaps);

      return productSearchResponseMapped;
    } catch (e) {
      console.error(e);
    }

    const searchResponse = await context.$search.api.search(params);

    return searchResponse;
  },
});

export default useSearch;
